import type { SupportIconProps } from '../Icon/SupportIconPropsNode';
import type { MdComponentIndexProps } from '../type';

type MarkdownStepProps = {
  title: string;
} & SupportIconProps &
  MdComponentIndexProps;

export function MarkdownStep(props: React.PropsWithChildren<MarkdownStepProps>) {
  return <></>;
}
const attributes: (keyof MarkdownStepProps)[] = ['title', 'icon', 'iconColor'];
MarkdownStep.attributes = attributes;
